import { useLazyQuery, useMutation } from "@apollo/client";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useSubmitOperation, {
  getMutationFunction,
  handleFormSubmission,
  usePrepareGraphQLVariables,
} from "../../../../CommonFunction/CustomUseFormSubmission";
import { replaceUnderscore } from "../../../../CommonFunction/common";
import { ClearSpecificForm } from "../../../../Store/FormDataReducer/FormFieldFunctions";
import { CREATE_CHARGE_MASTER, GET_CHARGEMASTER_BYID } from "../../../../Utils/AllPagesQuriesAndMutations";
import { FormInputSectionComponent } from "../../FormInputSectionComponent/FormInputSectionComponent";
import { handleFormReset, updateValueForm } from "../../FormInputSectionComponent/formUtils";
import { useModalContext } from "../../Reactportal/ModalContext";
import PortalFooter from "../../Reactportal/PortalFooter";
import Reactportal from "../../Reactportal/Reactportal";
import { ErrorToast } from "../../ToastComponent/RectHotToast";
import { ChargeFields } from "./AddChargeMasterConfig";
import useIsDisabled from "../../../custom_hooks/useIsDisabled";

const AddChargeMaster = ({ show, id, TypeOfPortal, submitType, ParentPortalCloseFunction }) => {
  const Form_Key = "Charge_Master";
  const [isFirstLoad, setFirstLoad] = useState(false);
  const formRef = useRef({});
  const { pushModal, popModal } = useModalContext();
  const [toggle, settoggle] = useState(show ? show : false);
  const [selectedRows, setSelectedRows] = useState([]);
  const fielddataRedux = useSelector((store) => store.UniqueTableReducer);
  const fielddata = fielddataRedux?.Charge_Management?.Selected_Row;
  const [allFieldsData, setAllFieldsData] = useState({});
  const FormDataFromRedux = useSelector((store) => store?.FormDataReducer);
  const dispatch = useDispatch();
  const [FormikFormData, setFormdata] = useState({});
  const [initialData,setInitialData]=useState({})
  const {isDisabled}=useIsDisabled({TypeOfPortal,initial:initialData, current:FormData});


  //Q & M
  const [createCharge, { loading: CreateLoading }] = useMutation(CREATE_CHARGE_MASTER);

  const [GetDataByID, { loading: GetDataByIDLoader }] = useLazyQuery(GET_CHARGEMASTER_BYID);

  const ChargeLoadingState = CreateLoading || GetDataByIDLoader;

  const HanldeChangeonForm = (values) => {
    setFormdata(prev=>{
      const next = {...prev,...values};
      if(!isFirstLoad){
        setInitialData(next)
      }
      return next
    })
  };

  useEffect(() => {
    pushModal(Form_Key);
    return () => {
      popModal(Form_Key)
    }
  }, []);

  useEffect(() => {
    if (TypeOfPortal !== "Add"&& TypeOfPortal !== "Delete") {
      console.log(fielddata, "fielddatafielddata");
      GetDataByID({
        variables: {
          id: fielddata?._id,
        },
      }).then(({ data }) => {
        const ChargeMasterData = data?.getAllAutoTransaction_ManagementByID[0];
        dispatch({
          type: "StoreMasterData",
          payload: {
            formkey: Form_Key,
            data: {
              Event_Code: ChargeMasterData.Event_Code,
            },
          },
        });
        ChargeMasterData.Event_Code = ChargeMasterData.Event_Code.Event_Name;
        console.log(ChargeMasterData, "ChargeMasterData");
        setAllFieldsData(ChargeMasterData);
        updateValueForm(formRef, ChargeMasterData);
      });
    } else {
      setAllFieldsData({});
    }
  }, [fielddata]);

  useEffect(() => {
    setSelectedRows(fielddataRedux?.Driver_Account?.Selected_Rows);
  }, [fielddataRedux]);

  const { executeOperation } = useSubmitOperation();
  const operationType = TypeOfPortal;
  let formData = FormikFormData;
  const variables = usePrepareGraphQLVariables(operationType, allFieldsData, formData, selectedRows);
  const BranchMutations = {
    CreatingData: createCharge,
  };
  const PageName = "Auto Transaction";

  const submit = async (closeAction) => {
    formData.Event_Code = FormDataFromRedux?.MasterData[Form_Key]?.Event_Code?._id;
    formData.Debit_Account = FormDataFromRedux?.MasterData[Form_Key]?.Debit_Account._id;
    formData.Credit_Account = FormDataFromRedux?.MasterData[Form_Key]?.Credit_Account._id;
    const mutationFunction = getMutationFunction(operationType, BranchMutations);
    const executeOperationFunction = () =>
      executeOperation({
        operationType,
        data: formData,
        selectedRows,
        Mutation: () => mutationFunction({ variables }),
        processDataBeforeSubmit: (data) => data,
        PageName,
        OnSuccess: (res) => {
          handleFormReset(formRef);
        },
      });
    handleFormSubmission(executeOperationFunction, {
      operationType,
      closeAction,
      closeFormFunction: Closeformfunction,
      resetFormDataFunction: () => {
        setAllFieldsData();
        handleFormReset(formRef);
      },
      onSuccess: () => {},
      onError: (error) => {
        ErrorToast(error.message);
      },
    });
  };

  const Closeformfunction = () => {
    ParentPortalCloseFunction();
    settoggle(false);
    setAllFieldsData({});
    ClearSpecificForm(dispatch, Form_Key);
  };

  const SaveAndCloseForAdd = () => {
    submit("Close");
  };



  const footerContent = (
    <PortalFooter
      renderContent={() => <></>}
      disabled={isDisabled}
      submitform={submit}
      Form_key={Form_Key}
      TypeOfPortal={TypeOfPortal}
      submitType={submitType}
      SaveAndClose={TypeOfPortal === "Add" ? SaveAndCloseForAdd : submit}
      handleformclose={() => {
        Closeformfunction();
        settoggle(!toggle);
      }}
      loadingState={ChargeLoadingState}
    />
  );
  return (
    <>
      <div>
        <Reactportal
          FoooterContent={footerContent}
          open={toggle}
          onClose={Closeformfunction}
          TypeOfPortal={TypeOfPortal+" "+ "Charge Management"}
        >
          <>
            {ChargeLoadingState && <div className="loader-line-div" />}
            <div className="formContainer">
              {ChargeFields.map((e, i) => {
                return (
                  <div key={e.id} className="FormSectionParent">
                    <div className="sectionHeadings">{replaceUnderscore(e.name)}</div>
                    <div key={i} className="FormSection insidecontainer">
                      <FormInputSectionComponent
                        inputfields={e.fields}
                        Type={e.name}
                        fielddata={allFieldsData}
                        onhandleFormikChange={HanldeChangeonForm}
                        TypeOfPortal={TypeOfPortal}
                        formkey={Form_Key}
                        formRef={formRef}
                        setFirstLoad={setFirstLoad}
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          </>
        </Reactportal>
      </div>
    </>
  );
};

export default AddChargeMaster;
